import { ReactElement, useMemo } from "react";
import { ValidGlobalSearchItemPersistedModel } from "../../Persistence/validation";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { SearchListItem } from "client/Features/Search/SearchListItem";
import { IntegrationFlowListItem } from "client/Features/Layout/TitleBar/GlobalSearch/Items/IntegrationFlowListItem";
import { useIntegrationFlowNavigationHandler } from "client/Features/Layout/TitleBar/GlobalSearch/Navigation/useIntegrationFlowNavigationHandler";
import { AppColorViewModel } from "client/Api/Apps/common";
import { AppImageDisplayInfo } from "client/Api/AppIcon/common";
import { generateTrackingId } from "client/Misc/utils";
import { TimeZone } from "client/DateAndTime/timezones";
import { convertAppColor, convertAppImage } from "../../Persistence/convertPersistedData";

export type IntegrationFlowItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.IntegrationFlow>;
	navigationIndex: number;
	index: number;
	onRemove: () => void;
	timezone: TimeZone;
};

export const IntegrationFlowItemView = (props: IntegrationFlowItemViewProps): ReactElement => {
	const {
		item,
		navigationIndex,
		index,
		onRemove,
		timezone
	} = props;

	const {
		title,
		dateTime,
		subTitle1,
		subTitle2,
		color: persistedColor,
		icon: persistedIcon,
		link
	} = item.integrationFlow;

	const executeHandler: () => void = useIntegrationFlowNavigationHandler({
		link,
		recentlyOpenedItem: item
	});

	const color = useMemo(
		(): AppColorViewModel => convertAppColor(persistedColor),
		[persistedColor]
	);

	const icon = useMemo(
		(): AppImageDisplayInfo => convertAppImage(persistedIcon),
		[persistedIcon]
	);

	return (
		<SearchListItem
			onExecute={executeHandler}
			trackingId={generateTrackingId("integration-flow-item", `|${index}`)}
		>
			<IntegrationFlowListItem
				title={title}
				dateTime={dateTime}
				subTitle1={subTitle1}
				subTitle2={subTitle2}
				color={color}
				icon={icon}
				timezone={timezone}
				onRemove={onRemove}
				itemIndex={navigationIndex}
				tabIndex={-1}
				onExecute={executeHandler}
			/>
		</SearchListItem>
	);
};
IntegrationFlowItemView.displayName = "IntegrationFlowItemView";